module.exports = __webpack_public_path__ + "img/placeholder6-opti.297e1e03.png";